@let logGroups = logService.logGroups$ | async;
<div class="dev-tools-container">
	<div class="search-container">
		<p-card>
			<form [formGroup]="logsQueryForm">
				<div class="search-bar">
					<p-floatlabel>
						<input pInputText formControlName="inputId" id="inputId" />
						<label for="inputId">{{ logsQueryForm.value.selectedType?.Name }}</label>
					</p-floatlabel>
					<p-button icon="pi pi-search" label="Search logs" [disabled]="searchDisabled" (onClick)="searchLogs()" [loading]="searchLoading"></p-button>
					<i class="pi pi-question-circle" tabindex="0" tooltipPosition="top" [pTooltip]="searchToolTip" style="cursor: pointer"></i>
				</div>
				<div class="search-filter">
					<div class="filter-item">
						<p-floatlabel>
							<p-multi-select
								id="log-groups"
								[options]="logGroups ?? []"
								[selectionLimit]="50"
								[formControl]="selectedLogGroupsForm"
								[showClear]="true"
								[style]="{ 'min-width': '200px' }"
								[maxSelectedLabels]="0"
								(onChange)="updateSavedSelection()"
								(onClear)="updateSavedSelection()"
								[loading]="!logGroups ? true : false"
							></p-multi-select>
							<i class="pi pi-question-circle tooltip-padding" tabindex="0" tooltipPosition="right" pTooltip="Select maximum 50 log groups"></i>
							<label for="log-groups">{{ logGroups ? 'Log groups' : 'Loading log groups' }}</label>
						</p-floatlabel>
					</div>
					<div class="filter-item">
						@for (type of types; track type) {
							<p-radiobutton formControlName="selectedType" [inputId]="type.Id" [value]="type"></p-radiobutton>
							<label for="type.id">{{ type.Name }}</label>
						}
					</div>
					<div class="filter-item">
						<p-floatlabel>
							<p-datepicker
								[firstDayOfWeek]="1"
								[showIcon]="true"
								[maxDate]="maxDate()"
								[showTime]="true"
								[stepMinute]="1"
								formControlName="endTime"
								dateFormat="yy-mm-dd"
								[showButtonBar]="true"
							></p-datepicker>
							<label for="date">End time</label>
						</p-floatlabel>
						<p-floatlabel>
							<p-inputnumber formControlName="lookbackTime" [min]="0" [max]="1440" [useGrouping]="true" [showButtons]="true"></p-inputnumber>
							<label for="loobackTime">Time span (min)</label>
						</p-floatlabel>
						<p-floatlabel>
							<p-inputnumber formControlName="limit" [min]="1" [max]="10000" [useGrouping]="true" [showButtons]="true"></p-inputnumber>
							<label for="loobackTime">Result limit</label>
						</p-floatlabel>
					</div>
				</div>
			</form>
		</p-card>
	</div>
	@if (
		{
			loading: logService.isLoadingDeliveries$ | async,
			logs: logs$ | async,
		};
		as data
	) {
		@if (data.logs && !data.loading) {
			<div class="results-container">
				<p-card>
					<p-table
						#dt1
						[value]="data.logs"
						[rows]="50"
						dataKey="Id"
						[rowsPerPageOptions]="[10, 50, 100]"
						[paginator]="true"
						[globalFilterFields]="['LogGroupName', 'Timestamp', 'Message', 'RawMessage']"
						[style]="{ 'max-width': '100%' }"
						[expandedRowKeys]="expandedRows"
						[showGridlines]="true"
						[rowExpandMode]="'single'"
						[scrollable]="false"
					>
						<ng-template pTemplate="caption">
							<div class="table-header">
								<span>
									<input pInputText #textInput type="text" (input)="dt1.filterGlobal(textInput.value, 'contains')" placeholder="Search keyword" />
								</span>
								<p-button label="Clear" severity="secondary" icon="pi pi-filter-slash" (onClick)="clearFilters(dt1)"></p-button>
							</div>
						</ng-template>
						<ng-template #header>
							<tr>
								<th pSortableColumn="Timestamp">
									Timestamp
									<p-sortIcon field="Timestamp"></p-sortIcon>
								</th>
								<th pColumn="Loglevel">Log level</th>
								<th Column="Application">Application</th>
								<th pColumn="Service">Service</th>
								<th pSortableColumn="LogGroupName">
									Log Group Name
									<p-sortIcon field="LogGroupName"></p-sortIcon>
								</th>
								<th>Log Stream Link</th>
							</tr>
						</ng-template>
						<ng-template #body let-log>
							<tr [pRowToggler]="log">
								<td>{{ log.Timestamp | date: 'yyyy-MM-dd HH:mm' }}</td>
								<td>{{ log.Message?.message?.level }}</td>
								<td>{{ log.Message?.message?.application }}</td>
								<td>{{ log.Message?.message?.service }}</td>
								<td>{{ log.LogGroupName }}</td>
								<td>
									<div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="0"><a [href]="log.LogStreamLink" target="_blank">CloudWatch</a></div>
								</td>
							</tr>
						</ng-template>
						<ng-template #expandedrow let-log>
							<tr>
								<td colspan="6">
									<div class="expanded-message">
										{{ log.Message | json }}
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</p-card>
			</div>
		}
	}
</div>
